import { createStore, combineReducers } from "lib/store";
import { afterChanges, afterDispatches } from "utils/store";
import { reducer as Role } from "./Role";

const reducers = { Role };

const reducer = combineReducers(reducers, afterDispatches, afterChanges);

export const {
  StoreProvider: RolesStoreProvider,
  useStore: useRolesStore,
  useSelector: useRolesSelector,
  useDispatch: useRolesDispatch
} = createStore(reducer);
